function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Common } from 'wsm-common-data';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import ReactDOM from 'react-dom';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }

  return target;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

var AND = 'AND';
var OR = 'OR';
var DETAILS = 'DETAILS';
var DISCLAIMER = 'DISCLAIMER';
var PERCENT_APR_FOR = 'PERCENT_APR_FOR';
var PER_MONTH = 'PER_MONTH';
var MONTHS = 'MONTHS';
var CASH_BACK = 'CASH_BACK';
var CASH_DUE_AT_SIGNING = 'CASH_DUE_AT_SIGNING';
var VIEW_APPLICABLE_VEHICLES = 'VIEW_APPLICABLE_VEHICLES';
var CASH_OFFER_FROM = 'CASH_OFFER_FROM';
var FINANCE_AND_CASH_OFFER_FROM = 'FINANCE_AND_CASH_OFFER_FROM';
var FINANCE_OR_CASH_OFFER_FROM = 'FINANCE_OR_CASH_OFFER_FROM';
var FINANCE_OFFER_FROM = 'FINANCE_OFFER_FROM';
var LEASE_OFFER_FROM = 'LEASE_OFFER_FROM';
var PROMOTION_FROM = 'PROMOTION_FROM'; // Temporary list of labels and the "labelObj" class to replicate labels.get() from ws-scripts
// Needed until <Common/> is broken out of ws-scripts for use in modules

var labels = {
  AND: {
    en: 'and',
    es: 'y',
    fr: 'et'
  },
  OR: {
    en: 'or',
    es: 'o',
    fr: 'ou'
  },
  DETAILS: {
    en: 'Details',
    es: 'Detalles',
    fr: 'Détails'
  },
  DISCLAIMER: {
    en: 'Disclaimer',
    es: 'Exención de responsabilidad',
    fr: 'Avertissement'
  },
  EFFECTIVE_THROUGH_X: {
    en: 'Effective through {{END_DATE}}',
    es: 'En vigencia hasta el {{END_DATE}}',
    fr: 'Efficace jusqu\'au {{END_DATE}}'
  },
  EFFECTIVE_X_THROUGH_X: {
    en: 'Effective {{START_DATE}} through {{END_DATE}}',
    es: 'Efectivo desde el {{START_DATE}} hasta el {{END_DATE}}',
    fr: 'En vigueur {{START_DATE}} à {{END_DATE}}'
  },
  PERCENT_APR_FOR: {
    en: '% APR for',
    es: '% tasa de porcentaje anual',
    fr: "% taux d'intérêt annuel"
  },
  PER_MONTH: {
    en: 'per month',
    es: 'por mes',
    fr: 'par mois'
  },
  MONTHS: {
    en: 'months',
    es: 'meses',
    fr: 'mois'
  },
  CASH_BACK: {
    en: 'cash back',
    es: 'reembolso',
    fr: 'argent en remise'
  },
  CASH_DUE_AT_SIGNING: {
    en: 'cash due at signing',
    es: 'pago en efectivo al firmar',
    fr: 'argent dû au moment de la signature'
  },
  VIEW_APPLICABLE_VEHICLES: {
    en: 'view applicable vehicles',
    es: 'ver vehículos aplicables',
    fr: 'voir les véhicules applicables'
  },
  CASH_OFFER_FROM: {
    en: 'Cash Offer from',
    es: 'Oferta en Efectivo de',
    fr: 'Offre en Espèces de'
  },
  FINANCE_AND_CASH_OFFER_FROM: {
    en: 'APR Finance and Cash Offer from',
    es: 'APR Finance y Oferta en Efectivo de',
    fr: 'APR Offre de Financement et en Espèces de'
  },
  FINANCE_OR_CASH_OFFER_FROM: {
    en: 'APR Finance or Cash Offer from',
    es: 'APR Finance o Oferta en Efectivo de',
    fr: 'APR Offre de Financement ou en Espèces de'
  },
  FINANCE_OFFER_FROM: {
    en: 'APR Finance Offer from',
    es: 'APR Finance Offer de',
    fr: 'APR Finance Offre de'
  },
  LEASE_OFFER_FROM: {
    en: 'Lease Offer from',
    es: 'Oferta de arrendamiento de',
    fr: 'Offre de location de'
  },
  PROMOTION_FROM: {
    en: 'Promotion from',
    es: 'Promoción desde',
    fr: 'Promotion à partir de'
  }
};

var LabelObj = function LabelObj() {
  var _this = this;

  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en_US';

  _classCallCheck$1(this, LabelObj);

  this.locale = locale;

  this.get = function () {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''; // Return untranslated label by default

    var translatedLabel = label;

    var language = _this.locale.split('_')[0];

    if (labels[label]) {
      if (labels[label][language]) {
        // Label exists for this language
        translatedLabel = labels[label][language];
      } else if (labels[label].en) {
        // Default to English
        translatedLabel = labels[label].en;
      }
    }

    return translatedLabel;
  };
};

var ListingLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(ListingLink, _React$Component); // TODO: remove constructor when <Common /> is added for labels


  function ListingLink(props) {
    var _this;

    _classCallCheck$1(this, ListingLink);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(ListingLink).call(this, props));
    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass$1(ListingLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentiveId = _this$props.incentiveId,
          incentiveAccountId = _this$props.incentiveAccountId,
          incentiveName = _this$props.incentiveName,
          condition = _this$props.condition,
          newListingPath = _this$props.newListingPath,
          usedListingPath = _this$props.usedListingPath;
      var url = '';

      if (condition === 'NEW') {
        url = newListingPath;
      } else {
        url = usedListingPath;
      }

      if (url) {
        url = "".concat(url, "?incentiveId=").concat(encodeURIComponent(incentiveId), "&incentiveAccountId=").concat(encodeURIComponent(incentiveAccountId));

        if (condition === 'CERTIFIED') {
          url = "".concat(url, "&compositeType=certified");
        }

        return React.createElement("a", {
          className: "small text-capitalize",
          href: url,
          "data-ga-event": "incentives|click|view inventory",
          "data-incentive-id": incentiveId,
          "data-incentive-name": incentiveName
        }, this.labels.get(VIEW_APPLICABLE_VEHICLES));
      } else {
        return null;
      }
    }
  }]);

  return ListingLink;
}(React.Component);

ListingLink.propTypes = {
  incentiveId: PropTypes.string.isRequired,
  incentiveAccountId: PropTypes.string.isRequired,
  incentiveName: PropTypes.string,
  condition: PropTypes.string,
  newListingPath: PropTypes.string,
  usedListingPath: PropTypes.string,
  locale: PropTypes.string.isRequired
};
ListingLink.defaultProps = {
  incentiveName: '',
  condition: 'NEW',
  newListingPath: null,
  usedListingPath: null
};

function parseIncentiveKey(key) {
  var incentiveInfo = {
    incentiveAccountId: '',
    incentiveId: ''
  };

  if (typeof key === 'string') {
    var keyParsed = key.split('_');

    if (keyParsed.length > 1) {
      incentiveInfo = {
        incentiveAccountId: keyParsed[0],
        incentiveId: keyParsed[1]
      };
    }
  }

  return incentiveInfo;
}

function formatNumber(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';

  if (typeof num !== 'number') {
    return '';
  }

  return new Intl.NumberFormat(locale.replace('_', '-')).format(num);
}

function formatCurrency(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var showFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = {
    style: 'currency',
    currency: locale.length && locale.indexOf('CA') > -1 ? 'CAD' : 'USD'
  };
  var currencyValue;

  if (typeof num !== 'number') {
    return '';
  }

  if (showFractionDigits) {
    // two fraction digits (aka decimal places) by default
    currencyValue = num;
  } else {
    currencyValue = Math.round(num);
    options.minimumFractionDigits = 0;
  }

  return new Intl.NumberFormat(locale.replace('_', '-'), options).format(currencyValue);
}

var TermsList =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(TermsList, _React$Component); // TODO: remove constructor when <Common /> is added for labels


  function TermsList(props) {
    var _this;

    _classCallCheck$1(this, TermsList);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(TermsList).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass$1(TermsList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          incentiveTerms = _this$props.incentiveTerms,
          locale = _this$props.locale;
      var termsList = null;

      if (incentiveTerms && incentiveTerms.length) {
        var terms;
        incentiveTerms.forEach(function (item) {
          terms = React.createElement(React.Fragment, null, terms, React.createElement("li", {
            className: "list-group-item p-0 pb-1"
          }, "".concat(formatNumber(item.value, locale)).concat(_this2.labels.get(PERCENT_APR_FOR), " ").concat(item.term, " ").concat(_this2.labels.get(MONTHS))));
        });
        termsList = React.createElement("ul", {
          className: "list-group list-group-flush mt-4"
        }, terms);
      }

      return termsList;
    }
  }]);

  return TermsList;
}(React.Component);

TermsList.propTypes = {
  incentiveTerms: PropTypes.arrayOf(PropTypes.shape({
    term: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  })),
  locale: PropTypes.string.isRequired
};
TermsList.defaultProps = {
  incentiveTerms: []
};

var SpecificDetails =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(SpecificDetails, _React$Component); // TODO: remove constructor when <Common /> is added for labels


  function SpecificDetails(props) {
    var _this;

    _classCallCheck$1(this, SpecificDetails);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(SpecificDetails).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass$1(SpecificDetails, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          locale = _this$props.locale,
          showEffectiveStartDate = _this$props.prefs.showEffectiveStartDate;
      var details = null;

      if (incentive && incentive.specific) {
        var effectiveDate = incentive.effectiveDate,
            expirationDate = incentive.expirationDate,
            specific = incentive.specific;
        var effectiveDates = React.createElement("p", null, showEffectiveStartDate.toLowerCase() === 'true' ? "".concat(this.labels.get('EFFECTIVE_X_THROUGH_X').replace(/({{\w+_?}})/gm, function (word) {
          if (word === '{{START_DATE}}') return effectiveDate;
          if (word === '{{END_DATE}}') return expirationDate;
        })) : "".concat(this.labels.get('EFFECTIVE_THROUGH_X').replace('{{END_DATE}}', expirationDate)));
        var cashBack = specific.cashOption ? React.createElement("p", null, "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null;
        var cashDue = specific.cashDue ? React.createElement("p", null, "".concat(formatCurrency(specific.cashDue, locale), " ").concat(this.labels.get(CASH_DUE_AT_SIGNING))) : null;
        var payment = specific.monthlyPayment ? React.createElement("p", null, "".concat(formatCurrency(specific.monthlyPayment, locale), " ").concat(this.labels.get(PER_MONTH)), specific.cashOption ? React.createElement(React.Fragment, null, React.createElement("br", null), "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null) : '';

        if (specific._type) {
          switch (specific._type) {
            case 'CASH':
              details = React.createElement(React.Fragment, null, cashBack, effectiveDates);
              break;

            case 'FINANCE':
              details = React.createElement(React.Fragment, null, React.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), effectiveDates, cashDue);
              break;

            case 'CASH_AND_FINANCE':
              details = React.createElement(React.Fragment, null, React.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? React.createElement(React.Fragment, null, React.createElement("p", null, this.labels.get(AND)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'CASH_OR_FINANCE':
              details = React.createElement(React.Fragment, null, React.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? React.createElement(React.Fragment, null, React.createElement("p", null, this.labels.get(OR)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'LEASE':
              // TODO: Missing "lease term" field from VCDA
              details = React.createElement(React.Fragment, null, payment, effectiveDates, cashDue);
              break;

            case 'UNDEFINED_TERM':
              // TODO: Missing "apr" field from VCDA
              details = React.createElement(React.Fragment, null, cashBack, effectiveDates, cashDue);
              break;

            default:
              // PROMOTION
              details = effectiveDates;
          }
        }
      }

      return details;
    }
  }]);

  return SpecificDetails;
}(React.Component);

SpecificDetails.propTypes = {
  incentive: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    offerDetails: PropTypes.string,
    shortTitle: PropTypes.string,
    disclaimer: PropTypes.string,
    effectiveDate: PropTypes.string,
    expirationDate: PropTypes.string,
    conditional: PropTypes.bool,
    make: PropTypes.string,
    condition: PropTypes.string,
    manufacturerOffer: PropTypes.bool,
    specific: PropTypes.object
  }).isRequired,
  locale: PropTypes.string.isRequired
};
var defaultClickEvent = {
  widgetId: '',
  widgetName: 'wsm-incentive-modal',
  widgetState: 'default',
  event: 'widgetUserEvent',
  element: '',
  elementCTA: undefined,
  action: 'clicked',
  result: '',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = window.jQuery(document) || {};

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function viewSpecialsDetailsEvent(widgetName, widgetId, elementCTA) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    element: 'Specials details link',
    elementCTA: elementCTA,
    result: 'Opened dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}

function closeSpecialsDetailsEvent(widgetName, widgetId) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    widgetState: 'Special dialog',
    element: 'Close button',
    result: 'Closed dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}

var IncentiveModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits$1(IncentiveModal, _React$Component);

  function IncentiveModal(props) {
    var _this;

    _classCallCheck$1(this, IncentiveModal);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(IncentiveModal).call(this, props)); // TODO: remove LabelObj when <Common /> is added for labels

    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    _this.onClose = _this.onClose.bind(_assertThisInitialized$1(_this));
    _this.onOpen = _this.onOpen.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  _createClass$1(IncentiveModal, [{
    key: "onOpen",
    value: function onOpen() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          _this$props$widgetInf = _this$props.widgetInfo,
          windowId = _this$props$widgetInf.windowId,
          widgetName = _this$props$widgetInf.widgetName; // Track when modal is opened

      if (incentive && Object.keys(incentive).length > 0) {
        var title = incentive.title;
        viewSpecialsDetailsEvent(widgetName, windowId, title);
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var _this$props2 = this.props,
          onModalClose = _this$props2.onModalClose,
          _this$props2$widgetIn = _this$props2.widgetInfo,
          windowId = _this$props2$widgetIn.windowId,
          widgetName = _this$props2$widgetIn.widgetName;
      onModalClose(); // Track when modal is closed

      closeSpecialsDetailsEvent(widgetName, windowId);
    }
  }, {
    key: "getOfferType",
    value: function getOfferType(specific, manufacturerOffer, make, accountName) {
      var issuer = accountName;

      if (manufacturerOffer) {
        issuer = make;
      }

      var typeHeading = PROMOTION_FROM;

      if (specific && specific._type) {
        switch (specific._type) {
          case 'CASH':
            typeHeading = CASH_OFFER_FROM;
            break;

          case 'FINANCE':
          case 'UNDEFINED_TERM':
            typeHeading = FINANCE_OFFER_FROM;
            break;

          case 'CASH_AND_FINANCE':
            typeHeading = FINANCE_AND_CASH_OFFER_FROM;
            break;

          case 'CASH_OR_FINANCE':
            typeHeading = FINANCE_OR_CASH_OFFER_FROM;
            break;

          case 'LEASE':
            typeHeading = LEASE_OFFER_FROM;
            break;

          default:
            // PROMOTION
            typeHeading = PROMOTION_FROM;
        }
      }

      return "".concat(this.labels.get(typeHeading), " ").concat(issuer);
    }
  }, {
    key: "getIncentiveDetails",
    value: function getIncentiveDetails() {
      var _this$props3 = this.props,
          incentive = _this$props3.incentive,
          newListingPath = _this$props3.newListingPath,
          usedListingPath = _this$props3.usedListingPath,
          account = _this$props3.account,
          locale = _this$props3.locale,
          prefs = _this$props3.prefs;
      var key = incentive.key,
          specific = incentive.specific,
          title = incentive.title,
          shortTitle = incentive.shortTitle,
          offerDetails = incentive.offerDetails,
          make = incentive.make,
          condition = incentive.condition,
          manufacturerOffer = incentive.manufacturerOffer;

      var _parseIncentiveKey = parseIncentiveKey(key),
          incentiveId = _parseIncentiveKey.incentiveId,
          incentiveAccountId = _parseIncentiveKey.incentiveAccountId;

      var offerType = this.getOfferType(specific, manufacturerOffer, make, account.name);
      return React.createElement(React.Fragment, null, React.createElement("h4", {
        className: "mt-2 mb-0 h5",
        "data-testid": "offerType"
      }, offerType), React.createElement("p", {
        className: "mt-0"
      }, title), React.createElement("h4", {
        className: "mt-2 mb-0 h5 text-capitalize"
      }, this.labels.get(DETAILS)), React.createElement("p", null, offerDetails), React.createElement(SpecificDetails, {
        incentive: incentive,
        locale: locale,
        prefs: prefs
      }), React.createElement(ListingLink, {
        incentiveId: incentiveId,
        incentiveAccountId: incentiveAccountId,
        incentiveName: shortTitle,
        condition: condition,
        newListingPath: newListingPath,
        usedListingPath: usedListingPath,
        locale: locale
      }));
    }
  }, {
    key: "getIncentiveDisclaimer",
    value: function getIncentiveDisclaimer(disclaimer) {
      var incentiveDisclaimer = null;

      if (disclaimer) {
        incentiveDisclaimer = React.createElement("div", {
          className: "text-muted small mt-4"
        }, React.createElement("p", null, "".concat(this.labels.get(DISCLAIMER), ": ").concat(disclaimer)));
      }

      return incentiveDisclaimer;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          incentive = _this$props4.incentive,
          isMobile = _this$props4.isMobile,
          isOpen = _this$props4.isOpen;
      var shortTitle = incentive.shortTitle,
          disclaimer = incentive.disclaimer;
      var incentiveDetails = this.getIncentiveDetails();
      var incentiveDisclaimer = this.getIncentiveDisclaimer(disclaimer);
      return React.createElement(Modal, {
        show: isOpen,
        onHide: this.onClose,
        onShow: this.onOpen,
        className: "m-1 ".concat(isMobile ? 'dock-right' : null)
      }, React.createElement(Modal.Header, null, React.createElement(Modal.Title, {
        className: "text-center"
      }, React.createElement("button", {
        type: "button",
        "aria-label": "Close",
        className: "close text-muted",
        onClick: this.onClose
      }, React.createElement("i", {
        className: "ddc-icon ddc-icon-close",
        "aria-hidden": "true"
      })), React.createElement("span", {
        className: "h3 my-0 px-5"
      }, shortTitle))), React.createElement(Modal.Body, null, incentiveDetails, incentiveDisclaimer));
    }
  }]);

  return IncentiveModal;
}(React.Component);

IncentiveModal.propTypes = {
  incentive: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    offerDetails: PropTypes.string,
    shortTitle: PropTypes.string,
    disclaimer: PropTypes.string,
    effectiveDate: PropTypes.string,
    expirationDate: PropTypes.string,
    conditional: PropTypes.bool,
    make: PropTypes.string,
    condition: PropTypes.string,
    manufacturerOffer: PropTypes.bool,
    specific: PropTypes.object
  }).isRequired,
  widgetInfo: PropTypes.shape({
    windowId: PropTypes.string.isRequired,
    widgetName: PropTypes.string.isRequired,
    deviceType: PropTypes.string.isRequired
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  account: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  newListingPath: PropTypes.string,
  usedListingPath: PropTypes.string,
  locale: PropTypes.string,
  prefs: PropTypes.shape({
    showEffectiveStartDate: PropTypes.string
  })
};
IncentiveModal.defaultProps = {
  newListingPath: null,
  usedListingPath: null,
  locale: 'en_US',
  prefs: {
    showEffectiveStartDate: 'true'
  }
};

var PLEASE_CALL = 'PLEASE_CALL';
var DETAILS$1 = 'DETAILS';
var PRICE = 'PRICE';
var UNKNOWN = 'UNKNOWN';
var CLOSE = 'CLOSE';
var VDP = 'VDP';
var SRP = 'SRP';
var OFFSET_HEIGHT = 66;
var BUTTON_RESET_CLASSES = 'p-0 text-left bg-transparent border-0';

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
var isBrowser = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object';
var getPriceItemLabel = function getPriceItemLabel(_ref) {
  var item = _ref.item,
      prefs = _ref.prefs,
      labels = _ref.labels;
  var title = item.title,
      shortTitle = item.shortTitle,
      typeCssClass = item.typeCssClass,
      isFinalPrice = item.isFinalPrice,
      incentiveId = item.incentiveId;
  var label = item.label; // Conditional final price label is coming from BE as a label ID and not a translated label.
  // TODO remove this logic once CONDITIONAL_FINAL_PRICE label is being properly translated from BE.

  if (label === 'CONDITIONAL_FINAL_PRICE') {
    label = labels.get('CONDITIONAL_FINAL_PRICE');
  }

  var titlePref = prefs.incentiveTitleDisplay;
  var priceItemLabel = label;

  if (incentiveId) {
    if (title && titlePref === 'regular') {
      priceItemLabel = title;
    }

    if (shortTitle && titlePref === 'descriptive') {
      priceItemLabel = shortTitle;
    }

    if (titlePref === 'custom' && typeCssClass === 'discount' && !isFinalPrice) {
      priceItemLabel = labels.get(prefs.incentiveTitleCustom);
    }
  }

  return priceItemLabel;
};
/**
 * Filters undefined, null or empty strings from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 */

var setClassNames = function setClassNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var flattened = classes.reduce(function (acc, cur) {
    return acc.concat(cur);
  }, []);
  return _toConsumableArray(new Set(flattened)).filter(function (c) {
    return c;
  }).join(' ') || null;
};
var getDefaultPriceItem = function getDefaultPriceItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultItem = {
    isFinalPrice: true,
    type: UNKNOWN,
    label: PRICE,
    value: PLEASE_CALL
  };
  return _objectSpread2({}, defaultItem, {}, overrides);
};
/**
 * Incentives from /getInventory have been merged into a map that contains multiple
 * incentiveIds in a string array as a key for their respective values to reduce data
 * This Maps incentive keys and values as a standard singly keyed object using incentiveIds as keys (1 key, 1 value)
 * @param {object} incentives
 */

var mapIncentiveKeys = function mapIncentiveKeys(incentives) {
  var incentiveObjKeys = Object.keys(incentives);
  var incentiveMap = {};
  incentiveObjKeys.forEach(function (originalKey) {
    var keysToArray = originalKey.replace(/\[|]|\s/gm, '').split(',');
    keysToArray.forEach(function (key) {
      incentiveMap[key] = incentives[originalKey];
    });
  });
  return incentiveMap;
};
var getLoanDisclaimerPlaceholderObj = function getLoanDisclaimerPlaceholderObj(paymentInfo) {
  // TODO: format numbers by locale on service side (WIS)
  var apr = paymentInfo.apr,
      dealershipName = paymentInfo.dealershipName,
      downPayment = paymentInfo.downPayment,
      lenderLegalName = paymentInfo.lenderLegalName,
      creditScore = paymentInfo.creditScore,
      monthlyPaymentPerThousand = paymentInfo.monthlyPaymentPerThousand,
      programEndDate = paymentInfo.programEndDate,
      term = paymentInfo.term;
  return {
    '<%=loanCreditScore%>': creditScore,
    '<%=APR%>': apr,
    '<%=term%>': term,
    '<%=monthlyPaymentPerThousand%>': formatter.format(monthlyPaymentPerThousand),
    '<%=downPayment%>': formatter.format(downPayment),
    '<%=lenderLegalName%>': lenderLegalName,
    '<%=loanProgramEndDate%>': programEndDate || '',
    '<%=dealershipName%>': dealershipName
  };
};
var getLeaseDisclaimerPlaceholderObj = function getLeaseDisclaimerPlaceholderObj(paymentInfo) {
  var creditScore = paymentInfo.creditScore,
      lenderLegalName = paymentInfo.lenderLegalName,
      programEndDate = paymentInfo.programEndDate,
      term = paymentInfo.term,
      leaseDueAtSigning = paymentInfo.leaseDueAtSigning,
      acquisitionFee = paymentInfo.acquisitionFee,
      capCostTotal = paymentInfo.capCostTotal,
      totalMonthlyPayment = paymentInfo.totalMonthlyPayment,
      capCostReduction = paymentInfo.capCostReduction,
      leaseSecurityDeposit = paymentInfo.leaseSecurityDeposit,
      value = paymentInfo.value,
      excessMileCharge = paymentInfo.excessMileCharge,
      annualMiles = paymentInfo.annualMiles,
      dealershipName = paymentInfo.dealershipName;
  return {
    '<%=leaseCreditScore%>': creditScore,
    '<%=leaseLenderLegalName%>': lenderLegalName,
    '<%=leaseProgramEndDate%>': programEndDate || '',
    '<%=leaseTerm%>': term,
    '<%=leaseDueAtSigning%>': formatter.format(leaseDueAtSigning),
    '<%=acquisitionFee%>': formatter.format(acquisitionFee),
    '<%=capCostTotal%>': formatter.format(capCostTotal),
    '<%=totalMonthlyPayments%>': formatter.format(totalMonthlyPayment),
    '<%=capCostReduction%>': formatter.format(capCostReduction),
    '<%=leaseSecurityDeposit%>': formatter.format(leaseSecurityDeposit),
    '<%=monthlyPayment%>': value,
    '<%=excessMileCharge%>': formatter.format(excessMileCharge),
    '<%=annualMiles%>': annualMiles,
    '<%=dealershipName%>': dealershipName
  };
};
var replacePlaceholders = function replacePlaceholders(labelWithPlaceholder, placeholderValuesObj) {
  // global and ignore case flags which permits replace() to replace each occurrence of matched items
  // ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  if (!placeholderValuesObj || Object.entries(placeholderValuesObj).length === 0) {
    if (!labelWithPlaceholder || Object.entries(labelWithPlaceholder).length === 0) {
      return 'Invalid Input';
    }

    return labelWithPlaceholder;
  }

  var regex = new RegExp(Object.keys(placeholderValuesObj).join('|'), 'gi');
  return labelWithPlaceholder.replace(regex, function (matched) {
    return placeholderValuesObj[matched];
  });
};
function getAccountId(rData) {
  return rData.parameterMap && rData.parameterMap.accountId || rData.accountId;
} // showOnlyMSRPForSharedInventory pref: shows only MSRP for shared inventory
// TODO: discuss adding this to IDC

var filterMSRP = function filterMSRP() {
  var priceItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var retailPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return priceItems.filter(function (priceItem) {
    return priceItem.value === retailPrice;
  });
}; // filters out the final price from the summaryItems array
// this data is consumed by the PricingSummary component

function filterFinal() {
  var summaryItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return summaryItems.filter(function (item) {
    return item.isFinalPrice;
  });
} // filters out the loan and lease from the summaryItems array
// this data is consumed by the PricingLoanLease component

function filterLoanLease() {
  var summaryItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return summaryItems.filter(function (item) {
    return item.type === 'LOAN' || item.type === 'LEASE';
  });
}
function extractEPriceData(ePriceDetail) {
  var ePriceDifference = '';
  var ePriceValue = '';

  if (ePriceDetail && ePriceDetail.length) {
    var ePriceIndex = ePriceDetail.findIndex(function (element) {
      return element.type === 'EPRICE';
    });

    if (ePriceIndex) {
      // ePrice difference should be placed before ePrice value per Rules Provider
      var difference = ePriceDetail[ePriceIndex];
      var ePrice = ePriceDetail[ePriceIndex + 1];
      ePriceDifference = difference ? difference.value : '';
      ePriceValue = ePrice ? ePrice.value : '';
    }
  }

  return {
    ePriceDifference: ePriceDifference,
    ePriceValue: ePriceValue
  };
}
function getDOMContainer(doc, cssClass) {
  var _doc$querySelectorAll = doc.querySelectorAll(cssClass),
      _doc$querySelectorAll2 = _slicedToArray(_doc$querySelectorAll, 1),
      container = _doc$querySelectorAll2[0];

  return container;
}
function getDisclaimerPlaceholderObj(paymentInfo) {
  if (paymentInfo.type === 'LOAN') {
    var apr = paymentInfo.apr,
        dealershipName = paymentInfo.dealershipName,
        downPayment = paymentInfo.downPayment,
        lenderLegalName = paymentInfo.lenderLegalName,
        loanCreditScore = paymentInfo.loanCreditScore,
        monthlyPaymentPerThousand = paymentInfo.monthlyPaymentPerThousand,
        loanProgramEndDate = paymentInfo.loanProgramEndDate,
        term = paymentInfo.term;
    return {
      '<%=loanCreditScore%>': loanCreditScore,
      '<%=APR%>': apr,
      '<%=term%>': term,
      '<%=monthlyPaymentPerThousand%>': monthlyPaymentPerThousand,
      '<%=downPayment%>': downPayment,
      '<%=lenderLegalName%>': lenderLegalName,
      '<%=loanProgramEndDate%>': loanProgramEndDate,
      '<%=dealershipName%>': dealershipName
    };
  } else if (paymentInfo.type === 'LEASE') {
    var leaseCreditScore = paymentInfo.leaseCreditScore,
        leaseLenderLegalName = paymentInfo.leaseLenderLegalName,
        leaseProgramEndDate = paymentInfo.leaseProgramEndDate,
        leaseTerm = paymentInfo.leaseTerm,
        leaseDueAtSigning = paymentInfo.leaseDueAtSigning,
        acquisitionFee = paymentInfo.acquisitionFee,
        capCostTotal = paymentInfo.capCostTotal,
        totalMonthlyPayments = paymentInfo.totalMonthlyPayments,
        capCostReduction = paymentInfo.capCostReduction,
        leaseSecurityDeposit = paymentInfo.leaseSecurityDeposit,
        monthlyPayment = paymentInfo.monthlyPayment,
        excessMileCharge = paymentInfo.excessMileCharge,
        annualMiles = paymentInfo.annualMiles,
        _dealershipName = paymentInfo.dealershipName;
    return {
      '<%=leaseCreditScore%>': leaseCreditScore,
      '<%=leaseLenderLegalName%>': leaseLenderLegalName,
      '<%=leaseProgramEndDate%>': leaseProgramEndDate,
      '<%=leaseTerm%>': leaseTerm,
      '<%=leaseDueAtSigning%>': leaseDueAtSigning,
      '<%=acquisitionFee%>': acquisitionFee,
      '<%=capCostTotal%>': capCostTotal,
      '<%=totalMonthlyPayments%>': totalMonthlyPayments,
      '<%=capCostReduction%>': capCostReduction,
      '<%=leaseSecurityDeposit%>': leaseSecurityDeposit,
      '<%=monthlyPayment%>': monthlyPayment,
      '<%=excessMileCharge%>': excessMileCharge,
      '<%=annualMiles%>': annualMiles,
      '<%=dealershipName%>': _dealershipName
    };
  }

  return {};
}

var PricingWrapper = function PricingWrapper(_ref) {
  var vehicleCssClass = _ref.vehicleCssClass,
      children = _ref.children;
  return React.createElement("dl", {
    className: setClassNames('pricing-detail', 'line-height-condensed', 'mb-4', vehicleCssClass)
  }, children);
};

PricingWrapper.propTypes = {
  vehicleCssClass: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired
};

var IncentiveButton = function IncentiveButton(_ref) {
  var incentiveId = _ref.incentiveId,
      isMobile = _ref.isMobile,
      children = _ref.children,
      handleDetailClick = _ref.handleDetailClick;
  return React.createElement("button", {
    type: "button",
    className: setClassNames('text-link', 'd-block', isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall'),
    onClick: function onClick() {
      handleDetailClick(incentiveId);
    }
  }, children);
};

IncentiveButton.propTypes = {
  incentiveId: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  handleDetailClick: PropTypes.func.isRequired
};

var PriceLabel = function PriceLabel(_ref) {
  var isStyleEditable = _ref.isStyleEditable,
      vehicleTypeClass = _ref.vehicleTypeClass,
      typeClass = _ref.typeClass,
      children = _ref.children;
  return (
    /* eslint react/no-danger: 0 */
    React.createElement("span", {
      className: "price-label",
      "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-label") : null,
      "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-label") : null
    }, children)
  );
};

PriceLabel.defaultProps = {
  isStyleEditable: false,
  vehicleTypeClass: '',
  typeClass: ''
};
PriceLabel.propTypes = {
  isStyleEditable: PropTypes.bool,
  vehicleTypeClass: PropTypes.string,
  typeClass: PropTypes.string,
  children: PropTypes.element.isRequired
};

var PriceTitlePortal = function PriceTitlePortal(_ref) {
  var vehicleId = _ref.vehicleId,
      price = _ref.price,
      priceLabel = _ref.priceLabel,
      showTitlePriceLabel = _ref.showTitlePriceLabel;
  var titleRoot = null;

  if (!(typeof window === 'undefined') && window.document) {
    titleRoot = document.getElementById("".concat(vehicleId, "_priceTitle"));
  }

  var priceTitle = React.createElement(React.Fragment, null, showTitlePriceLabel === 'true' && React.createElement("small", {
    className: "d-block"
  }, priceLabel), price);
  return titleRoot && ReactDOM.createPortal(priceTitle, titleRoot) || null;
};

// without wrapping in a button which will have display issues

var ClickArea = function ClickArea(_ref) {
  var title = _ref.title,
      children = _ref.children,
      handleClick = _ref.handleClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  // TODO: re-enable these rules by making this component fully accessible

  /* eslint jsx-a11y/click-events-have-key-events: 0 */

  /* eslint jsx-a11y/interactive-supports-focus: 0 */
  return React.createElement("span", {
    role: "button",
    onClick: handleClick,
    onKeyDown: handleClick,
    tabIndex: tabIndex,
    "aria-label": title
  }, children);
};

ClickArea.propTypes = {
  children: PropTypes.element.isRequired,
  handleClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  tabIndex: PropTypes.number.isRequired
};

var PriceItem = function PriceItem(_ref) {
  var _ref$item = _ref.item,
      type = _ref$item.type,
      incentiveId = _ref$item.incentiveId,
      value = _ref$item.value,
      isFinalPrice = _ref$item.isFinalPrice,
      _ref$item$typeClass = _ref$item.typeClass,
      typeClass = _ref$item$typeClass === void 0 ? '' : _ref$item$typeClass,
      isDiscount = _ref$item.isDiscount,
      item = _ref.item,
      incentives = _ref.incentives,
      stackType = _ref.stackType,
      isMobile = _ref.isMobile,
      _ref$prefs = _ref.prefs,
      priceDiscountColor = _ref$prefs.priceDiscountColor,
      finalPriceSize = _ref$prefs.finalPriceSize,
      finalPriceColor = _ref$prefs.finalPriceColor,
      showTitlePriceLabel = _ref$prefs.showTitlePriceLabel,
      vehicleCssClass = _ref.vehicleCssClass,
      isFirstItem = _ref.isFirstItem,
      handleDetailClick = _ref.handleDetailClick,
      vehicleId = _ref.vehicleId;
  var formattedPrice = value;
  var adjustmentDetected = false;
  var hasLineBreak = false;
  var isStackedFinal = type === 'SICF' || type === 'SIF';
  var isTotal = type === 'TOTAL' || // Represents the last price in the rule
  type === 'SICF' || // Final price including conditional incentives
  type === 'SIF' || // Final price including stack incentives
  isFinalPrice;
  var isConditionalFinal = type === 'SICF';
  var isEpriceFinal = stackType === 'ePrice' && isFinalPrice;
  var isIncentive = !!incentiveId;

  if ((isStackedFinal || isTotal) && !isFirstItem) {
    hasLineBreak = true;
  }

  if (isDiscount) {
    adjustmentDetected = true;
    hasLineBreak = false;
  } else {
    if (adjustmentDetected === true) {
      hasLineBreak = true;
    }

    adjustmentDetected = false;
  }

  var discountValueCssClass = '';
  var totalValueCssClass = '';
  var ePriceCssClass = '';
  var itemCssClass = typeClass && typeClass.toLowerCase() || '';
  var valueCssClass = '';

  if (value === PLEASE_CALL) {
    valueCssClass = 'no-value';
    formattedPrice = React.createElement(Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(PLEASE_CALL);
      }
    });
  }

  if ((isDiscount || isIncentive) && value !== PLEASE_CALL) {
    formattedPrice = isMobile ? "- ".concat(value) : "-".concat(value);
    discountValueCssClass = "".concat(priceDiscountColor);
  } // TODO: Refactor condition once WIS has retailPrice field


  if (isTotal && !!isFinalPrice || value === PLEASE_CALL || type === 'SICF') {
    totalValueCssClass = 'font-weight-bold'; // suppressing finalPriceSize for total pricing that contains PLEASE_CALL value

    if (value !== PLEASE_CALL) {
      totalValueCssClass = "".concat(totalValueCssClass, " ").concat(finalPriceSize, " line-height-reset pb-2");
    }
  }

  if (isEpriceFinal) {
    ePriceCssClass = 'eprice';
  }

  if (isConditionalFinal) {
    totalValueCssClass = "".concat(totalValueCssClass, " text-muted");
  }

  var priceTitlePortal = null; // WIS has bug where isFinalPrice will be on multiple price items
  // we don't want to render multiple portals to the title area

  if (isFinalPrice === true && type !== 'MIDDLE') {
    itemCssClass = 'final-price';
    totalValueCssClass = "".concat(totalValueCssClass, " ").concat(finalPriceColor);

    if (value !== PLEASE_CALL) {
      priceTitlePortal = React.createElement(PriceTitlePortal, {
        vehicleId: vehicleId,
        price: value,
        priceLabel: item.label,
        showTitlePriceLabel: showTitlePriceLabel,
        key: "".concat(vehicleId, "-price-title-portal")
      });
    }
  }

  var isStyleEditable = vehicleCssClass !== '' && itemCssClass !== '';
  var lineBreakMarkup = React.createElement("dd", {
    className: "pricing-divider my-3",
    key: "".concat(type, "-divider")
  });
  var labelMarkup = React.createElement(Common, {
    render: function render(_ref3) {
      var prefs = _ref3.prefs,
          labels = _ref3.labels;
      var itemWithIncentiveTitles = isIncentive && incentives && incentives[incentiveId] ? _objectSpread2({}, item, {
        title: incentives[incentiveId].title,
        shortTitle: incentives[incentiveId].shortTitle
      }) : _objectSpread2({}, item);
      var label = getPriceItemLabel({
        item: itemWithIncentiveTitles,
        prefs: prefs,
        labels: labels
      });
      var incentiveButton = isIncentive && incentives[incentiveId] ? React.createElement(IncentiveButton, _extends({
        incentiveId: incentiveId,
        isMobile: isMobile,
        handleDetailClick: handleDetailClick
      }, {
        key: "".concat(type, "-button")
      }), labels.get(DETAILS$1)) : null;

      if (label && label._type) {
        label = label.en_US;
      }

      return [React.createElement(PriceLabel, _extends({
        isStyleEditable: isStyleEditable,
        itemCssClass: itemCssClass,
        vehicleCssClass: vehicleCssClass
      }, {
        key: "".concat(type, "-label")
      }), labels.getHTML(label)), incentiveButton];
    }
  });
  var labelMarkupWithClick = React.createElement(Common, {
    render: function render(_ref4) {
      var labels = _ref4.labels;
      return React.createElement(ClickArea, {
        handleClick: function handleClick(e) {
          if (e.type === 'click' || e.type === 'keydown' && (e.which === 13 || e.which === 32)) {
            handleDetailClick(incentiveId);
          }
        },
        title: labels.get(DETAILS$1),
        tabIndex: 0
      }, labelMarkup);
    }
  });
  var valueMarkup = React.createElement("span", {
    className: setClassNames('price-value', valueCssClass),
    "data-style-editor-id": isStyleEditable ? "vdp-".concat(itemCssClass, "-price-value") : null,
    "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleCssClass, ".pricing-detail .").concat(itemCssClass, " .price-value") : null
  }, formattedPrice);
  var valueMarkupWithClick = React.createElement(Common, {
    render: function render(_ref5) {
      var labels = _ref5.labels;
      return React.createElement(ClickArea, {
        handleClick: function handleClick() {
          handleDetailClick(incentiveId);
        },
        title: labels.get(DETAILS$1),
        tabIndex: 0
      }, valueMarkup);
    }
  });
  return [priceTitlePortal, hasLineBreak ? lineBreakMarkup : '', React.createElement("dt", {
    "data-style-editor-price": isStyleEditable ? 'true' : null,
    className: setClassNames(isIncentive ? 'pointer' : '', isStyleEditable ? itemCssClass : ''),
    key: "".concat(type, "-dt")
  }, isIncentive ? labelMarkupWithClick : labelMarkup), React.createElement("dd", {
    "data-style-editor-price": isStyleEditable ? 'true' : null,
    className: setClassNames(discountValueCssClass, totalValueCssClass, ePriceCssClass, isIncentive ? 'pointer' : '', isStyleEditable ? itemCssClass : ''),
    key: "".concat(type, "-dd")
  }, isIncentive ? valueMarkupWithClick : valueMarkup)];
};

PriceItem.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    isFinalPrice: PropTypes.bool,
    incentiveId: PropTypes.string,
    typeClass: PropTypes.string,
    isDiscount: PropTypes.bool
  }),
  incentives: PropTypes.shape({}).isRequired,
  stackType: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  prefs: PropTypes.shape({
    priceDiscountColor: PropTypes.string,
    finalPriceSize: PropTypes.string,
    finalPriceColor: PropTypes.string,
    showTitlePriceLabel: PropTypes.string
  }).isRequired,
  vehicleCssClass: PropTypes.string.isRequired,
  isFirstItem: PropTypes.bool.isRequired,
  vehicleId: PropTypes.string.isRequired
};
PriceItem.defaultProps = {
  item: {
    value: '',
    isFinalPrice: false,
    incentiveId: '',
    typeClass: '',
    isDiscount: false
  },
  prefs: {
    priceDiscountColor: null,
    finalPriceSize: null,
    finalPriceColor: null,
    showTitlePriceLabel: 'false'
  }
};

var FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE';
var FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE';
var EST_FINANCE_DISCLAIMER_HEADING = 'EST_FINANCE_DISCLAIMER_HEADING';
var EST_LEASE_DISCLAIMER_HEADING = 'EST_LEASE_DISCLAIMER_HEADING';
var FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE';
var THE_DEALERSHIP = 'THE_DEALERSHIP';
var CUSTOMIZE_PAYMENTS = 'CUSTOMIZE_PAYMENTS';
var DEALERSHIP_NAME_PRICE = 'DEALERSHIP_NAME_PRICE';
var DETAILED_PRICING = 'DETAILED_PRICING';
var DETAILS$2 = 'DETAILS';
var PLEASE_CALL$1 = 'PLEASE_CALL';
var PLUS_SALES_TAXES_ASTERISK = 'PLUS_SALES_TAXES_ASTERISK';
var PLUS_TAXES_ASTERISK = 'PLUS_TAXES_ASTERISK';
var SLASH_MO = 'SLASH_MO';
var CLICK_TO_VIEW_DISCLAIMER = 'CLICK_TO_VIEW_DISCLAIMER';

var DisclaimerContent = function DisclaimerContent(_ref) {
  var dealershipName = _ref.dealershipName,
      disclaimerLabel = _ref.disclaimerLabel,
      placeholderValuesObj = _ref.placeholderValuesObj;
  return React.createElement(Common, {
    render: function render(_ref2) {
      var labels = _ref2.labels;
      var introParagraph = labels.get(FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE);
      var dealershipText = dealershipName === THE_DEALERSHIP ? labels.get(THE_DEALERSHIP) : dealershipName;
      var disclaimerHtml = replacePlaceholders(labels.get(disclaimerLabel), _objectSpread2({}, placeholderValuesObj, {
        '<%=dealershipName%>': dealershipText
      }));
      /* eslint react/no-danger: 0 */

      return [React.createElement("div", {
        key: "introHtml",
        dangerouslySetInnerHTML: {
          __html: introParagraph
        }
      }), React.createElement("div", {
        key: "disclaimerHtml",
        dangerouslySetInnerHTML: {
          __html: disclaimerHtml
        }
      })];
    }
  });
};

DisclaimerContent.propTypes = {
  dealershipName: PropTypes.string.isRequired,
  disclaimerLabel: PropTypes.string.isRequired,
  placeholderValuesObj: PropTypes.shape().isRequired
};

var LoanLeaseModal = function LoanLeaseModal(_ref) {
  var options = _extends({}, _ref);

  var showState = options.showState,
      closeMethod = options.closeMethod,
      title = options.title,
      body = options.body,
      isMobile = options.isMobile;
  var modalClass = isMobile ? 'dock-right' : null;
  return React.createElement(Modal, {
    show: showState,
    onHide: function onHide() {
      return closeMethod();
    },
    className: "m-1 ".concat(modalClass)
  }, React.createElement("div", {
    className: "p-1"
  }, React.createElement(Modal.Header, null, React.createElement(Modal.Title, {
    className: "text-center"
  }, React.createElement(Common, {
    render: function render(_ref2) {
      var labels = _ref2.labels;
      return React.createElement("button", {
        type: "button",
        "aria-label": labels.get(CLOSE),
        className: "close text-muted",
        onClick: function onClick() {
          return closeMethod();
        }
      }, React.createElement("i", {
        className: "ddc-icon ddc-icon-close",
        "aria-hidden": "true"
      }));
    }
  }), React.createElement("div", {
    className: "my-0 px-5 h3"
  }, title))), React.createElement(Modal.Body, null, body)));
};
LoanLeaseModal.propTypes = {
  showState: PropTypes.bool.isRequired,
  closeMethod: PropTypes.func.isRequired,
  body: PropTypes.element.isRequired
};

var Payments = function Payments(_ref) {
  var _ref$loan = _ref.loan,
      loan = _ref$loan === void 0 ? {} : _ref$loan,
      _ref$lease = _ref.lease,
      lease = _ref$lease === void 0 ? {} : _ref$lease,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$accountInfo = _ref.accountInfo,
      accountInfo = _ref$accountInfo === void 0 ? {} : _ref$accountInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDisclaimer = _useState2[0],
      setShowDisclaimer = _useState2[1];

  var _useState3 = useState(React.createElement("span", null)),
      _useState4 = _slicedToArray(_useState3, 2),
      disclaimerTitle = _useState4[0],
      setDisclaimerTitle = _useState4[1];

  var _useState5 = useState(React.createElement("span", null)),
      _useState6 = _slicedToArray(_useState5, 2),
      disclaimerContent = _useState6[0],
      setDisclaimerContent = _useState6[1];

  var toggleDisclaimer = function toggleDisclaimer() {
    var disclaimerTitleMarkup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : React.createElement("span", null);
    var disclaimerContentMarkup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : React.createElement("span", null);
    setShowDisclaimer(!showDisclaimer);
    setDisclaimerTitle(disclaimerTitleMarkup);
    setDisclaimerContent(disclaimerContentMarkup);
  };

  var icon = React.createElement("i", {
    className: "ddc-icon ddc-icon-help-circle text-muted ddc-icon-size-small d-inline-block pl-1"
  });

  var getLoanLeaseModalOptions = function getLoanLeaseModalOptions() {
    return {
      isMobile: isMobile,
      showState: showDisclaimer,
      closeMethod: toggleDisclaimer,
      title: disclaimerTitle,
      body: disclaimerContent
    };
  };

  var renderPayment = function renderPayment(item, labels) {
    var label = item.label,
        value = item.value;
    var isLease = item.type === 'lease';
    var disclaimer = isLease ? FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE : FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
    var disclaimerPlaceholder = isLease ? getLeaseDisclaimerPlaceholderObj(item) : getLoanDisclaimerPlaceholderObj(item);
    var disclaimerTitleKey = isLease ? EST_LEASE_DISCLAIMER_HEADING : EST_FINANCE_DISCLAIMER_HEADING;
    var DynamicDisclaimerContent = React.createElement(DisclaimerContent, {
      placeholderValuesObj: disclaimerPlaceholder,
      disclaimerLabel: disclaimer,
      dealershipName: accountInfo.name
    });
    return React.createElement(React.Fragment, null, React.createElement("dt", null, React.createElement("button", {
      type: "button",
      className: "btn-link p-0",
      onClick: function onClick() {
        return toggleDisclaimer(labels.get(disclaimerTitleKey), DynamicDisclaimerContent);
      }
    }, React.createElement("span", {
      className: "price-label"
    }, label, icon))), React.createElement("dd", null, React.createElement("span", {
      className: "price-value font-weight-bold"
    }, value), React.createElement("span", {
      className: "text-muted"
    }, labels.get('SLASH_MO'))));
  };

  var loanItem = _objectSpread2({}, loan, {
    type: 'loan'
  });

  var leaseItem = _objectSpread2({}, lease, {
    type: 'lease'
  }); // eslint-disable-next-line react/prop-types


  var renderLayout = function renderLayout(_ref2) {
    var labels = _ref2.labels;
    return React.createElement(React.Fragment, null, loan && loanItem.value && renderPayment(loanItem, labels), lease && leaseItem.value && renderPayment(leaseItem, labels));
  };

  var options = getLoanLeaseModalOptions();
  return React.createElement(React.Fragment, null, React.createElement(Common, {
    render: renderLayout
  }), React.createElement(LoanLeaseModal, options));
};

Payments.defaultProps = {
  loan: {},
  lease: {}
};
Payments.propTypes = {
  loan: PropTypes.shape({}),
  lease: PropTypes.shape({}),
  isMobile: PropTypes.bool.isRequired,
  accountInfo: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }).isRequired
};

var defaultClickEvent$1 = {
  event: 'widgetUserEvent',
  element: 'More details button',
  elementCTA: 'Details',
  action: 'clicked',
  result: 'Revealed detail information popup',
  widgetName: 'ws-detailed-pricing',
  widgetId: 'detailed-pricing1',
  widgetState: 'default',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent$1(eventData) {
  var trackingObject = {};

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
    trackingObject = window.jQuery(document) || {};
  }

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread2({}, defaultClickEvent$1, {}, eventData));
  }
}

function priceDetailsScrollEvent(widgetName, widgetId) {
  var eventData = {
    element: 'Price details link',
    elementCTA: 'Pricing Detail',
    result: 'Scrolled to destination',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent$1(eventData);
}
function disclaimerDetailsModalEvents(widgetName, widgetId, modalState) {
  var eventData;

  if (modalState) {
    eventData = {
      element: 'Disclaimer details link',
      elementCTA: undefined,
      result: 'Opened dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  } else {
    eventData = {
      element: 'Close button',
      elementCTA: undefined,
      result: 'Closed dialog',
      widgetState: 'Disclaimer dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  }

  trackGoogleAnalyticsEvent$1(eventData);
}
function ePriceButtonTrackEvent(buttonLabel, widgetName, widgetId, openModal) {
  var eventData = {
    element: 'Instant ePrice button',
    elementCTA: buttonLabel,
    result: openModal ? 'Opened dialog' : 'ePrice diplayed',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent$1(eventData);
}

var InstantEpriceButton = function InstantEpriceButton(_ref) {
  var isModalVisible = _ref.isModalVisible,
      loadingUserProfile = _ref.loadingUserProfile,
      userLoggedIn = _ref.userLoggedIn,
      ePriceDetail = _ref.ePriceDetail,
      handleClick = _ref.handleClick,
      buttonLabel = _ref.buttonLabel,
      buttonStyle = _ref.buttonStyle,
      buttonSize = _ref.buttonSize,
      vehicleId = _ref.vehicleId,
      vehicleCategory = _ref.vehicleCategory,
      pageAlias = _ref.pageAlias,
      disabled = _ref.disabled,
      preventMultipleEpriceLeads = _ref.preventMultipleEpriceLeads;

  if (!buttonLabel) {
    return null;
  }

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      labels = _useSelector.labels;

  var _useSelector2 = useSelector(function (state) {
    return state.requestData;
  }),
      widgetName = _useSelector2.widgetName,
      windowId = _useSelector2.windowId;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      epriceDisplayData = _useState2[0],
      setEpriceDisplayData = _useState2[1];

  useEffect(function () {
    var _window = window,
        pubsub = _window.pubsub;

    if (pubsub && epriceDisplayData) {
      pubsub.subscribe('instant-eprice.complete', function () {
        if (ePriceDetail) {
          var _extractEPriceData = extractEPriceData(epriceDisplayData),
              ePriceValue = _extractEPriceData.ePriceValue,
              ePriceDifference = _extractEPriceData.ePriceDifference;

          pubsub.publish('instant-eprice.show', {
            ePriceDifference: ePriceDifference,
            yourEPrice: ePriceValue
          });
        }
      });
    }
  }, [epriceDisplayData]);
  var formUrl = "/instant-eprice-form.htm?itemId=".concat(vehicleId, "&vehicleId=").concat(vehicleId, "&category=").concat(vehicleCategory) + "&parentPageAlias=".concat(pageAlias, "&vcdaInstantEPrice");

  var allowLeadSubmission = function allowLeadSubmission() {
    // Don't submit a lead if preventMultipleEpriceLeads preference is set and
    // user has already submitted one
    return !(preventMultipleEpriceLeads && window.DDC.userProfile.ePriceVehicles && window.DDC.userProfileController.hasUserContactData());
  };

  var submitLeadConditionally = function submitLeadConditionally() {
    if (userLoggedIn && allowLeadSubmission()) {
      window.DDC.userProfileController.sendLeadForm(formUrl);
    }
  };

  var openModalOrSubmitLead = function openModalOrSubmitLead() {
    var _window2 = window,
        DDC = _window2.DDC;

    if (DDC) {
      if (userLoggedIn) {
        // Save eprice vehicle to profile
        DDC.toolbar.saveEpriceVehicleStatus(vehicleId); // Save eprice vehicle in session for guest user

        DDC.userProfileController.saveInstantEpriceVehicle(null, vehicleId);
      } else {
        // Provide data for dialog display
        DDC.currentVLPDialog = {
          instantEpriceUrl: formUrl,
          instantEpriceVehicleId: vehicleId
        };
        setEpriceDisplayData(ePriceDetail);
      }
    }

    try {
      handleClick(vehicleId);
    } catch (error) {
      throw new Error('Unable to handle click.');
    } finally {
      submitLeadConditionally();
    }

    ePriceButtonTrackEvent(buttonLabel, widgetName, windowId, false);
  };

  var buttonAttributes = {
    className: setClassNames('btn-block', 'btn', "btn-".concat(buttonStyle), buttonSize && buttonSize !== 'default' ? "btn-".concat(buttonSize) : null, 'instant-eprice', userLoggedIn ? 'slidein-disabled' : 'dialog', isModalVisible ? 'd-none' : null),
    'data-width': '600px',
    'data-location': 'vehicle-eprice-button'
  };
  var tooltip = React.createElement(Tooltip, {
    className: "tooltip",
    id: "eprice-tooltip"
  }, labels.INSTANT_EPRICE_DISABLED_POPOVER);
  var disabledButton = React.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4"
  }, React.createElement("button", _extends({}, buttonAttributes, {
    type: "button",
    disabled: true
  }), buttonLabel));
  return disabled ? React.createElement("div", {
    className: "disabled"
  }, typeof window !== 'undefined' && window.document ? React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: tooltip,
    trigger: ['hover', 'click']
  }, disabledButton) : disabledButton) : React.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4"
  }, React.createElement("button", _extends({}, buttonAttributes, {
    type: "button",
    onClick: openModalOrSubmitLead,
    rel: "nofollow",
    "data-vehicle-uuid": vehicleId,
    "data-name": "instant-price-dialog",
    "data-href": userLoggedIn ? null : formUrl
  }), loadingUserProfile && React.createElement(React.Fragment, null, React.createElement("i", {
    className: "mr-3 ddc-icon ddc-icon-loading ddc-icon-animate-spin",
    "aria-hidden": "true"
  }), React.createElement("span", {
    className: "sr-only"
  }, labels.LOADING)), buttonLabel), React.createElement("div", {
    key: "label",
    className: setClassNames('instanteprice-pending', 'font-weight-bold', 'text-success', 'text-center', isModalVisible ? null : 'd-none')
  }, labels.EPRICE_PENDING));
};

InstantEpriceButton.propTypes = {
  ePriceDetail: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    key: PropTypes.string,
    isFinalPrice: PropTypes.bool,
    incentives: PropTypes.arrayOf(PropTypes.string)
  })),
  isModalVisible: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  loadingUserProfile: PropTypes.bool.isRequired,
  userLoggedIn: PropTypes.bool.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  buttonStyle: PropTypes.string.isRequired,
  buttonSize: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  vehicleId: PropTypes.string.isRequired,
  vehicleCategory: PropTypes.string.isRequired,
  pageAlias: PropTypes.string.isRequired,
  preventMultipleEpriceLeads: PropTypes.bool.isRequired
};
InstantEpriceButton.defaultProps = {
  ePriceDetail: []
};

var InstantEpriceContainer = function InstantEpriceContainer(_ref) {
  var isMobile = _ref.isMobile,
      ePriceDetail = _ref.ePriceDetail,
      buttonLabel = _ref.buttonLabel,
      buttonStyle = _ref.buttonStyle,
      buttonSize = _ref.buttonSize,
      disabled = _ref.disabled,
      preventMultipleEpriceLeads = _ref.preventMultipleEpriceLeads,
      instantEpriceShowAllAfterLeadSubmit = _ref.instantEpriceShowAllAfterLeadSubmit,
      showEPrice = _ref.showEPrice,
      _ref$widgetInfo = _ref.widgetInfo,
      pageAlias = _ref$widgetInfo.pageAlias,
      vehicleId = _ref$widgetInfo.vehicleId,
      vehicleCategory = _ref$widgetInfo.vehicleCategory;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setIsModalVisible = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoadingUserProfile = _useState4[0],
      setIsLoadingUserProfile = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isUserLoggedIn = _useState6[0],
      setIsUserLoggedIn = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      userProfile = _useState8[0],
      setUserProfile = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      epriceVehicle = _useState10[0],
      setEpriceVehicle = _useState10[1];

  var showModal = function showModal(id) {
    setIsModalVisible(true);
    setEpriceVehicle(id);
  };

  var handleClick = function handleClick(id) {
    return isUserLoggedIn ? showEPrice(id) : showModal(id);
  };

  var updateUserState = function updateUserState() {
    var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (profile && Object.entries(profile).length !== 0) {
      var ePriceVehicles = profile.ePriceVehicles,
          profileId = profile.profileId;
      setIsUserLoggedIn(ePriceVehicles !== undefined || profileId !== undefined);
      setUserProfile(profile);
    } else {
      setIsUserLoggedIn(false);
      setUserProfile(null);
      showEPrice('none');
    }
  };

  useEffect(function () {
    var _window = window,
        DDC = _window.DDC,
        $ = _window.$;

    if (DDC) {
      if ($) {
        $.subscribe('userProfile-updated', function () {
          return updateUserState(DDC.userProfile);
        });
      }

      if (DDC.userProfile) {
        updateUserState(DDC.userProfile);
        setIsLoadingUserProfile(false);
      }

      if (isMobile && DDC.mobile.slidein) {
        // Required to make instant eprice work on mobile
        DDC.mobile.slidein.init();
      }
    }
  }, []);
  useEffect(function () {
    var _window2 = window,
        DDC = _window2.DDC,
        pubsub = _window2.pubsub;

    if (pubsub) {
      if (epriceVehicle && isModalVisible) {
        pubsub.subscribe('instant-eprice.complete', function () {
          showEPrice(epriceVehicle);
          updateUserState(DDC.userProfile);
          setEpriceVehicle(null);
        });
        pubsub.subscribe('instant-eprice.cancel', function () {
          setIsModalVisible(false);
        });
      }
    }
  }, [isModalVisible, epriceVehicle]);
  useEffect(function () {
    if (userProfile) {
      var ePriceVehicles = userProfile.ePriceVehicles;

      if (instantEpriceShowAllAfterLeadSubmit === 'true' && !isModalVisible) {
        showEPrice(vehicleId);
      } else if (ePriceVehicles) {
        var isEpriceVehicle = ePriceVehicles.find(function (vehicle) {
          return vehicle.itemUUID === vehicleId;
        }); // User has the vehicle in their profile

        if (isEpriceVehicle && !isModalVisible) {
          showEPrice(vehicleId);
        }
      }
    }
  }, [userProfile]);
  return React.createElement(InstantEpriceButton, {
    userLoggedIn: isUserLoggedIn,
    loadingUserProfile: isLoadingUserProfile,
    isModalVisible: isModalVisible,
    ePriceDetail: ePriceDetail,
    buttonLabel: buttonLabel,
    buttonStyle: buttonStyle,
    buttonSize: buttonSize,
    handleClick: handleClick,
    vehicleId: vehicleId,
    vehicleCategory: vehicleCategory,
    pageAlias: pageAlias,
    disabled: disabled,
    preventMultipleEpriceLeads: preventMultipleEpriceLeads
  });
};

InstantEpriceContainer.propTypes = {
  showEPrice: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  ePriceDetail: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    key: PropTypes.string,
    isFinalPrice: PropTypes.bool,
    incentives: PropTypes.arrayOf(PropTypes.string)
  })),
  buttonLabel: PropTypes.string.isRequired,
  buttonStyle: PropTypes.string,
  buttonSize: PropTypes.string,
  widgetInfo: PropTypes.shape({
    vehicleId: PropTypes.string.isRequired,
    vehicleCategory: PropTypes.string.isRequired,
    pageAlias: PropTypes.string.isRequired,
    windowId: PropTypes.string.isRequired,
    widgetName: PropTypes.string.isRequired
  }).isRequired,
  instantEpriceShowAllAfterLeadSubmit: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  preventMultipleEpriceLeads: PropTypes.bool.isRequired
};
InstantEpriceContainer.defaultProps = {
  ePriceDetail: [],
  buttonStyle: 'primary',
  buttonSize: 'default',
  instantEpriceShowAllAfterLeadSubmit: 'false'
};

var DisclaimersModal = function DisclaimersModal(props) {
  var isModalVisible = props.isModalVisible,
      handleClose = props.handleClose,
      paymentInfo = props.paymentInfo;

  if (!paymentInfo) {
    return null;
  }

  var modalBody = '';
  var title = '';
  var type = paymentInfo.type,
      dealershipName = paymentInfo.dealershipName;
  var placeholderValuesObj = getDisclaimerPlaceholderObj(paymentInfo);

  if (type === 'LOAN') {
    title = React.createElement(Common, {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(EST_FINANCE_DISCLAIMER_HEADING);
      }
    });
    modalBody = React.createElement(DisclaimerContent, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  if (type === 'LEASE') {
    title = React.createElement(Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(EST_LEASE_DISCLAIMER_HEADING);
      }
    });
    modalBody = React.createElement(DisclaimerContent, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  return React.createElement(Modal, {
    show: isModalVisible,
    onHide: handleClose
  }, React.createElement(Modal.Header, {
    closeButton: true
  }, React.createElement(Modal.Title, {
    className: "text-center"
  }, React.createElement("span", {
    className: "h3"
  }, title))), React.createElement(Modal.Body, null, modalBody));
};

DisclaimersModal.defaultProps = {
  paymentInfo: null
};
DisclaimersModal.propTypes = {
  isModalVisible: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  paymentInfo: PropTypes.shape()
};

var LabelAsHTML = function LabelAsHTML(props) {
  var label = props.label,
      isStyleEditable = props.isStyleEditable,
      vehicleTypeClass = props.vehicleTypeClass,
      typeClass = props.typeClass;
  return (
    /* eslint react/no-danger: 0 */
    React.createElement("span", {
      className: "price-label",
      "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-label") : null,
      "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-label") : null,
      dangerouslySetInnerHTML: {
        __html: label
      }
    })
  );
};

LabelAsHTML.defaultProps = {
  isStyleEditable: false,
  vehicleTypeClass: '',
  typeClass: ''
};
LabelAsHTML.propTypes = {
  label: PropTypes.string.isRequired,
  isStyleEditable: PropTypes.bool,
  vehicleTypeClass: PropTypes.string,
  typeClass: PropTypes.string
};

var PricingSummaryFinalPrice = function PricingSummaryFinalPrice(_ref) {
  var price = _ref.price,
      buttonResetClasses = _ref.buttonResetClasses,
      viewPriceDetail = _ref.viewPriceDetail,
      finalLabelSize = _ref.finalLabelSize,
      finalPrice = _ref.finalPrice,
      finalPriceSize = _ref.finalPriceSize;

  if (price && price.isFinalPrice && finalPrice && viewPriceDetail) {
    return React.createElement("button", {
      className: "".concat(buttonResetClasses, " w-100"),
      onClick: viewPriceDetail,
      type: "button"
    }, React.createElement("span", {
      className: setClassNames('text-muted', 'd-block', finalLabelSize)
    }, React.createElement(LabelAsHTML, {
      label: price.label
    }), ' '), React.createElement("strong", {
      className: setClassNames('line-height-reset', finalPriceSize)
    }, finalPrice));
  }

  return null;
};

PricingSummaryFinalPrice.propTypes = {
  price: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    isFinalPrice: PropTypes.bool.isRequired
  }).isRequired,
  buttonResetClasses: PropTypes.string,
  viewPriceDetail: PropTypes.func.isRequired,
  finalLabelSize: PropTypes.string,
  finalPrice: PropTypes.string.isRequired,
  finalPriceSize: PropTypes.string
};
PricingSummaryFinalPrice.defaultProps = {
  buttonResetClasses: '',
  finalLabelSize: '',
  finalPriceSize: ''
};

var PricingSummaryPayments = function PricingSummaryPayments(_ref) {
  var price = _ref.price,
      paymentLabelSize = _ref.paymentLabelSize,
      paymentPrice = _ref.paymentPrice,
      paymentPriceSize = _ref.paymentPriceSize,
      handleHelpCircleIcon = _ref.handleHelpCircleIcon,
      pricingSummaryPaymentIntervalColor = _ref.pricingSummaryPaymentIntervalColor,
      pricingSummaryLoanLeaseHelpIconColor = _ref.pricingSummaryLoanLeaseHelpIconColor;

  if (price && !price.isFinalPrice && paymentPrice) {
    return React.createElement("span", {
      className: "flex-grow-1"
    }, React.createElement("span", {
      className: setClassNames('text-muted', 'text-nowrap', 'd-block', paymentLabelSize)
    }, React.createElement(Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return React.createElement(LabelAsHTML, {
          label: labels.get(price.label)
        });
      }
    }), React.createElement("button", {
      className: "text-link line-height-reset help-icon",
      onClick: handleHelpCircleIcon,
      type: "button"
    }, React.createElement("i", {
      className: setClassNames('ddc-icon', 'ddc-icon-help-circle', 'd-inline-block', 'pl-1', pricingSummaryLoanLeaseHelpIconColor),
      "aria-hidden": "true"
    }), React.createElement(Common, {
      render: function render(_ref3) {
        var labels = _ref3.labels;
        return React.createElement("span", {
          className: "sr-only"
        }, labels.get(CLICK_TO_VIEW_DISCLAIMER));
      }
    }))), React.createElement("strong", {
      className: setClassNames('line-height-reset', paymentPriceSize)
    }, paymentPrice), React.createElement("span", {
      className: setClassNames('ddc-font-size-small', 'd-inline', 'line-height-reset', pricingSummaryPaymentIntervalColor)
    }, React.createElement(Common, {
      render: function render(_ref4) {
        var labels = _ref4.labels;
        return labels.get(SLASH_MO);
      }
    })));
  }

  return null;
};

PricingSummaryPayments.propTypes = {
  price: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    isFinalPrice: PropTypes.bool.isRequired
  }).isRequired,
  paymentLabelSize: PropTypes.string,
  paymentPrice: PropTypes.string.isRequired,
  paymentPriceSize: PropTypes.string,
  handleHelpCircleIcon: PropTypes.func.isRequired,
  pricingSummaryPaymentIntervalColor: PropTypes.string,
  pricingSummaryLoanLeaseHelpIconColor: PropTypes.string
};
PricingSummaryPayments.defaultProps = {
  paymentLabelSize: '',
  paymentPriceSize: '',
  pricingSummaryPaymentIntervalColor: '',
  pricingSummaryLoanLeaseHelpIconColor: ''
};

var PricingSummaryLink = function PricingSummaryLink(_ref) {
  var label = _ref.label,
      labelFontSize = _ref.labelFontSize,
      isCalculatePayment = _ref.isCalculatePayment,
      viewPriceDetail = _ref.viewPriceDetail;
  var calcPaymentClasses = isCalculatePayment ? ['calculate-payment-integrated', 'calculate-payment-scroll-up'] : [];

  if (label) {
    return React.createElement("button", {
      onClick: !isCalculatePayment ? viewPriceDetail : null,
      type: "button",
      className: setClassNames.apply(void 0, ['text-link', 'text-left', 'd-block', 'line-height-reset', labelFontSize].concat(calcPaymentClasses))
    }, React.createElement(Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(label);
      }
    }));
  }

  return null;
};

PricingSummaryLink.propTypes = {
  label: PropTypes.string.isRequired,
  labelFontSize: PropTypes.string,
  isCalculatePayment: PropTypes.bool,
  viewPriceDetail: PropTypes.func
};
PricingSummaryLink.defaultProps = {
  labelFontSize: '',
  isCalculatePayment: false,
  viewPriceDetail: function viewPriceDetail() {}
};

var CaDisclaimer = function CaDisclaimer(_ref) {
  var dealerAddress = _ref.dealerAddress,
      isFooter = _ref.isFooter;
  var CAAlternateDisclaimerProvinces = ['AB', 'BC', 'MB', 'ON', 'QC', 'SK'];
  var staticDisclaimerClasses = 'final-price-disclaimer ddc-font-size-xsmall text-muted w-100 ';
  var disclaimerClasses = staticDisclaimerClasses + (isFooter ? 'text-left summary-disclaimer' : 'text-right');
  var disclaimerLabel = PLUS_TAXES_ASTERISK;

  if (CAAlternateDisclaimerProvinces.includes(dealerAddress.state)) {
    disclaimerLabel = PLUS_SALES_TAXES_ASTERISK;
  }

  if (dealerAddress.country === 'CA') {
    return React.createElement("div", {
      className: disclaimerClasses
    }, React.createElement(Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(disclaimerLabel);
      }
    }));
  } else {
    return null;
  }
};
CaDisclaimer.propTypes = {
  dealerAddress: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string
  })
};
CaDisclaimer.defaultProps = {
  dealerAddress: {},
  isFooter: false
};

___$insertStyle("ul.pricing-summary li.summary-price {\n  max-width: 40%;\n}\nul.pricing-summary li.half-width {\n  min-width: 50%;\n}\nul.pricing-summary li.third-width {\n  min-width: 33%;\n}\n\n.vdp-sidebar.responsive-content-default .ws-detailed-pricing ul.pricing-summary {\n  display: none !important;\n}");

var getFormattedValue = function getFormattedValue(value) {
  var formattedValue = value;

  if (formattedValue === PLEASE_CALL$1) {
    formattedValue = React.createElement(Common, {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(PLEASE_CALL$1);
      }
    });
  }

  return formattedValue;
};

var PricingSummary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummary, _React$Component);

  function PricingSummary(props) {
    var _this;

    _classCallCheck(this, PricingSummary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummary).call(this, props));
    _this.state = {
      isModalVisible: false,
      paymentInfo: null
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PricingSummary, [{
    key: "closeModal",
    value: function closeModal() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      disclaimerDetailsModalEvents(widgetName, windowId, false);
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "handleHelpCircleIcon",
    value: function handleHelpCircleIcon(paymentInfo) {
      var _this$props$widgetInf2 = this.props.widgetInfo,
          widgetName = _this$props$widgetInf2.widgetName,
          windowId = _this$props$widgetInf2.windowId;
      disclaimerDetailsModalEvents(widgetName, windowId, true);
      this.setState({
        isModalVisible: true,
        paymentInfo: paymentInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$summary = _this$props.summary,
          summary = _this$props$summary === void 0 ? [] : _this$props$summary,
          isMobile = _this$props.isMobile,
          viewPriceDetail = _this$props.viewPriceDetail;
      var _this$props$prefs = this.props.prefs,
          showStickySidebarLoanLease = _this$props$prefs.showStickySidebarLoanLease,
          finalPriceFontWeight = _this$props$prefs.finalPriceFontWeight,
          finalPriceClasses = _this$props$prefs.finalPriceClasses,
          priceLabelClasses = _this$props$prefs.priceLabelClasses,
          pricingSummaryPaymentIntervalColor = _this$props$prefs.pricingSummaryPaymentIntervalColor,
          showCustomizePaymentsLink = _this$props$prefs.showCustomizePaymentsLink,
          pricingSummaryLoanLeaseHelpIconColor = _this$props$prefs.pricingSummaryLoanLeaseHelpIconColor,
          pricingSummaryAlignItems = _this$props$prefs.pricingSummaryAlignItems;
      var finalLabelSize = isMobile ? 'ddc-font-size-base' : 'ddc-font-size-small';
      var finalPriceSize = isMobile ? 'ddc-font-size-xxlarge' : 'ddc-font-size-xlarge';
      var paymentLabelSize = isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall';
      var paymentPriceSize = isMobile ? 'ddc-font-size-xlarge' : 'ddc-font-size-large';
      var summaryLength = summary.length;
      var pricingSummary;

      if (summaryLength === 0) {
        return null;
      } else if (summaryLength > 1 && showStickySidebarLoanLease === 'true') {
        var finalPriceSummary = filterFinal(summary);
        var paymentsSummary = filterLoanLease(summary);
        var _this$state = this.state,
            isModalVisible = _this$state.isModalVisible,
            paymentInfo = _this$state.paymentInfo;
        pricingSummary = React.createElement("div", null, React.createElement(DisclaimersModal, {
          isModalVisible: isModalVisible,
          handleClose: this.closeModal,
          paymentInfo: paymentInfo
        }), React.createElement("ul", {
          className: setClassNames('pricing-summary', 'list-unstyled', 'd-flex', 'justify-items-between', 'mb-4', pricingSummaryAlignItems)
        }, React.createElement("li", {
          className: setClassNames(summaryLength <= 2 ? 'half-width' : 'third-width', ' d-flex', 'flex-wrap', 'mr-4', 'summary-price')
        }, finalPriceSummary.map(function (price) {
          return React.createElement(PricingSummaryFinalPrice, _extends({
            price: price,
            viewPriceDetail: viewPriceDetail,
            finalLabelSize: finalLabelSize,
            finalPriceSize: finalPriceSize,
            paymentLabelSize: paymentLabelSize
          }, {
            key: price.type,
            buttonResetClasses: BUTTON_RESET_CLASSES,
            finalPrice: getFormattedValue(price.value)
          }));
        }), React.createElement(PricingSummaryLink, {
          label: DETAILED_PRICING,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: false,
          viewPriceDetail: viewPriceDetail
        })), React.createElement("li", {
          className: "d-flex flex-wrap flex-grow-1"
        }, paymentsSummary.map(function (price) {
          return React.createElement(PricingSummaryPayments, _extends({
            price: price,
            paymentLabelSize: paymentLabelSize,
            paymentPriceSize: paymentPriceSize,
            pricingSummaryPaymentIntervalColor: pricingSummaryPaymentIntervalColor,
            pricingSummaryLoanLeaseHelpIconColor: pricingSummaryLoanLeaseHelpIconColor
          }, {
            key: price.type,
            paymentPrice: getFormattedValue(price.value),
            handleHelpCircleIcon: function handleHelpCircleIcon() {
              return _this2.handleHelpCircleIcon(price);
            }
          }));
        }), showCustomizePaymentsLink === 'true' && React.createElement(PricingSummaryLink, {
          label: CUSTOMIZE_PAYMENTS,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: true
        }))));
      } else {
        // single item (final price) will get detailed pricing markup
        // TODO: REPLACE THIS WITH GET FINAL PRICE
        var _summary$find = summary.find(function (price) {
          return price.isFinalPrice;
        }),
            label = _summary$find.label,
            value = _summary$find.value;

        var dealerAddress = this.props.dealerAddress;
        /* eslint react/no-danger: 0 */

        pricingSummary = React.createElement("dl", {
          className: "pricing-detail final-price line-height-condensed mb-4"
        }, React.createElement("dt", {
          className: priceLabelClasses || null
        }, React.createElement("button", {
          className: BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail,
          type: "button"
        }, React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        }), React.createElement(PricingSummaryLink, {
          label: DETAILED_PRICING,
          labelFontSize: paymentLabelSize
        }))), React.createElement("dd", {
          className: setClassNames(finalPriceFontWeight, finalPriceSize, finalPriceClasses)
        }, React.createElement("button", {
          className: BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail,
          type: "button"
        }, getFormattedValue(value))), React.createElement(CaDisclaimer, {
          dealerAddress: dealerAddress
        }));
      }

      return pricingSummary;
    }
  }]);

  return PricingSummary;
}(React.Component);
PricingSummary.displayName = 'PricingSummary';
PricingSummary.propTypes = {
  prefs: PropTypes.shape({
    showStickySidebarLoanLease: PropTypes.string,
    finalPriceFontWeight: PropTypes.string,
    finalPriceClasses: PropTypes.string,
    priceLabelClasses: PropTypes.string,
    pricingSummaryPaymentIntervalColor: PropTypes.string,
    showCustomizePaymentsLink: PropTypes.string,
    pricingSummaryLoanLeaseHelpIconColor: PropTypes.string,
    pricingSummaryAlignItems: PropTypes.string
  }).isRequired,
  summary: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  viewPriceDetail: PropTypes.func.isRequired,
  widgetInfo: PropTypes.shape({
    windowId: PropTypes.string.isRequired,
    widgetName: PropTypes.string.isRequired,
    deviceType: PropTypes.string.isRequired
  }).isRequired,
  dealerAddress: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string
  }),
  isMobile: PropTypes.bool
};
PricingSummary.defaultProps = {
  dealerAddress: {},
  isMobile: false
};

var PricingSummaryPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryPortal, _React$Component);

  function PricingSummaryPortal() {
    _classCallCheck(this, PricingSummaryPortal);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryPortal).apply(this, arguments));
  }

  _createClass(PricingSummaryPortal, [{
    key: "render",
    value: function render() {
      this.containerEl = getDOMContainer(document, '.ddc-vehicle-pricing-summary');
      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary,
          prefs = _this$props.prefs,
          widgetInfo = _this$props.widgetInfo,
          isMobile = _this$props.isMobile;
      var summaryComp = React.createElement(PricingSummary, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      }); // if there is a pricing summary, render in portal

      if (this.containerEl) {
        return ReactDOM.createPortal(summaryComp, this.containerEl);
      }

      return null;
    }
  }]);

  return PricingSummaryPortal;
}(React.Component);
PricingSummaryPortal.propTypes = {
  prefs: PropTypes.shape({
    showStickySidebarLoanLease: PropTypes.string
  }).isRequired,
  summary: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired,
  widgetInfo: PropTypes.shape({
    windowId: PropTypes.string.isRequired,
    widgetName: PropTypes.string.isRequired,
    deviceType: PropTypes.string.isRequired
  }).isRequired,
  viewPriceDetail: PropTypes.func.isRequired,
  dealerAddress: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string
  }),
  isMobile: PropTypes.bool.isRequired
};
PricingSummaryPortal.defaultProps = {
  dealerAddress: {}
};

___$insertStyle(".mobile .ws-detailed-pricing ul.pricing-summary,\n.mobile .ws-detailed-pricing .final-price-disclaimer.summary-disclaimer {\n  display: none;\n}\n.mobile .fixed-vdp-footer .ws-detailed-pricing ul.pricing-summary,\n.mobile .fixed-vdp-footer .ws-detailed-pricing .final-price-disclaimer {\n  display: block;\n}");

var PricingSummaryFooter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooter, _React$Component);

  function PricingSummaryFooter() {
    _classCallCheck(this, PricingSummaryFooter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooter).apply(this, arguments));
  }

  _createClass(PricingSummaryFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          summary = _this$props.summary,
          dealershipName = _this$props.dealershipName,
          viewPriceDetail = _this$props.viewPriceDetail;
      var displayPrice = summary.find(function (price) {
        return price.isFinalPrice;
      });

      if (!displayPrice) {
        return null;
      }

      return React.createElement(Common, {
        render: function render(_ref) {
          var labels = _ref.labels;
          var dealershipNamePriceText = replacePlaceholders(labels.get(DEALERSHIP_NAME_PRICE), {
            // THIS SHOULD BE A SEPARATE PROP!
            '<%=dealershipName%>': dealershipName
          });
          var formattedValue = displayPrice.value;

          if (formattedValue === PLEASE_CALL$1) {
            formattedValue = labels.get(PLEASE_CALL$1);
          }

          return (// using aria-hidden based on conversation with Rachael Arnold
            // and Jon Ferry. The data in the footer section is redundant
            // and comes after the detailed pricing data in the DOM
            React.createElement("div", {
              onClick: viewPriceDetail,
              role: "button",
              "aria-hidden": true
            }, React.createElement("ul", {
              className: "pricing-summary list-unstyled line-height-condensed mb-2"
            }, React.createElement("li", {
              className: "text-muted"
            }, React.createElement("span", {
              className: "d-block text-truncate"
            }, dealershipNamePriceText)), React.createElement("li", null, React.createElement("strong", {
              className: "pr-3"
            }, formattedValue), React.createElement("span", {
              className: "text-link"
            }, labels.get(DETAILS$2)))))
          );
        }
      });
    }
  }]);

  return PricingSummaryFooter;
}(React.Component);
PricingSummaryFooter.propTypes = {
  summary: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired,
  dealershipName: PropTypes.string.isRequired,
  viewPriceDetail: PropTypes.func.isRequired
};

var PricingSummaryFooterPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooterPortal, _React$Component);

  function PricingSummaryFooterPortal(props) {
    var _this;

    _classCallCheck(this, PricingSummaryFooterPortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooterPortal).call(this, props));
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(PricingSummaryFooterPortal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.containerEl) {
        this.containerEl.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.containerEl = getDOMContainer(document, '.ddc-detailed-pricing-footer');

      if (this.containerEl) {
        this.containerEl.appendChild(this.el);
      }

      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary,
          dealershipName = _this$props.dealershipName;
      var summaryComp = React.createElement("div", null, React.createElement(PricingSummaryFooter, {
        summary: summary,
        viewPriceDetail: viewPriceDetail,
        dealershipName: dealershipName
      }), React.createElement(CaDisclaimer, {
        dealerAddress: dealerAddress,
        isFooter: true
      })); // if there is a pricing footer, render in portal

      if (this.containerEl) {
        return ReactDOM.createPortal(summaryComp, this.el);
      }

      return summaryComp;
    }
  }]);

  return PricingSummaryFooterPortal;
}(React.Component);
PricingSummaryFooterPortal.propTypes = {
  summary: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired,
  dealerAddress: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string
  }),
  viewPriceDetail: PropTypes.func.isRequired,
  dealershipName: PropTypes.string.isRequired
};
PricingSummaryFooterPortal.defaultProps = {
  dealerAddress: {}
};

var PricingSummaryContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryContainer, _React$Component);

  function PricingSummaryContainer(props) {
    var _this;

    _classCallCheck(this, PricingSummaryContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryContainer).call(this, props));
    _this.viewPriceDetail = _this.viewPriceDetail.bind(_assertThisInitialized(_this));
    _this.scrollToAnchor = _this.scrollToAnchor.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PricingSummaryContainer, [{
    key: "viewPriceDetail",
    value: function viewPriceDetail() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      priceDetailsScrollEvent(widgetName, windowId);
      this.scrollToAnchor();
    }
  }, {
    key: "scrollToAnchor",
    value: function scrollToAnchor() {
      var deviceType = this.props.widgetInfo.deviceType;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';
      var headerSelector = document && document.querySelector('[data-widget-id="template-navigation1"]');
      var scrollToSelector = '[data-widget-id="vehicle-title1"]';

      if (isMobile) {
        headerSelector = document && document.querySelector('[data-widget-id="template-navbar1"]');
        scrollToSelector = '[data-widget-id="detailed-pricing1"]';
      }

      var pageHeaderHeight = headerSelector && headerSelector.clientHeight || 0;

      if (window && window.DDC && window.DDC.scrollToAnchor) {
        window.DDC.scrollToAnchor($(scrollToSelector), {
          heightAdj: pageHeaderHeight + OFFSET_HEIGHT
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          deviceType = _this$props.widgetInfo.deviceType,
          dealerAddress = _this$props.dealerAddress,
          prefs = _this$props.prefs,
          summary = _this$props.summary,
          widgetInfo = _this$props.widgetInfo,
          dealershipName = _this$props.dealershipName;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';

      if (isMobile) {
        if (isBrowser) {
          return React.createElement(React.Fragment, null, React.createElement(PricingSummaryPortal, {
            prefs: prefs,
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            widgetInfo: widgetInfo,
            dealerAddress: dealerAddress,
            isMobile: isMobile
          }), React.createElement(PricingSummaryFooterPortal, {
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            dealerAddress: dealerAddress,
            dealershipName: dealershipName
          }));
        }

        return null;
      }

      return React.createElement(PricingSummary, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: this.viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      });
    }
  }]);

  return PricingSummaryContainer;
}(React.Component);
PricingSummaryContainer.propTypes = {
  prefs: PropTypes.shape({
    showStickySidebarLoanLease: PropTypes.string
  }).isRequired,
  summary: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  widgetInfo: PropTypes.shape({
    windowId: PropTypes.string.isRequired,
    widgetName: PropTypes.string.isRequired,
    deviceType: PropTypes.string.isRequired
  }).isRequired,
  dealerAddress: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string
  }),
  dealershipName: PropTypes.string.isRequired
};
PricingSummaryContainer.defaultProps = {
  dealerAddress: {}
};

var PricingDetail = function PricingDetail(_ref) {
  var _ref$pricing = _ref.pricing,
      _ref$pricing$lease = _ref$pricing.lease,
      lease = _ref$pricing$lease === void 0 ? {} : _ref$pricing$lease,
      _ref$pricing$loan = _ref$pricing.loan,
      loan = _ref$pricing$loan === void 0 ? {} : _ref$pricing$loan,
      _ref$pricing$retailPr = _ref$pricing.retailPrice,
      retailPrice = _ref$pricing$retailPr === void 0 ? '' : _ref$pricing$retailPr,
      pricing = _ref.pricing,
      incentives = _ref.incentives,
      accountInfo = _ref.accountInfo,
      vehicleId = _ref.vehicleId,
      vehicleCategory = _ref.vehicleCategory,
      condition = _ref.condition,
      pageAlias = _ref.pageAlias,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? SRP : _ref$layout;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setIsModalVisible = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      incentive = _useState4[0],
      setIncentive = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDisplayingEprice = _useState6[0],
      setIsDisplayingEprice = _useState6[1]; // TODO: pass these as props (using redux store keys may cause conflicts)


  var prefs = useSelector(function (state) {
    return state.prefs;
  });
  var requestData = useSelector(function (state) {
    return state.requestData;
  });
  var dealerAddress = useSelector(function (state) {
    return state.dealerAddress;
  });
  var flags = useSelector(function (state) {
    return state.flags;
  });
  var locale = requestData.locale,
      deviceType = requestData.deviceType;
  var priceDiscountColor = prefs.priceDiscountColor,
      finalPriceSize = prefs.finalPriceSize,
      finalPriceColor = prefs.finalPriceColor,
      showTitlePriceLabel = prefs.showTitlePriceLabel,
      showOnlyMSRPForSharedInventory = prefs.showOnlyMSRPForSharedInventory,
      instantEpricePreventMultipleEpriceLeads = prefs.instantEpricePreventMultipleEpriceLeads,
      showInstantEpriceForSharedInventory = prefs.showInstantEpriceForSharedInventory,
      instantEpriceShowAllAfterLeadSubmit = prefs.instantEpriceShowAllAfterLeadSubmit,
      buttonStyleEPrice = prefs.buttonStyleEPrice,
      buttonSizeEPrice = prefs.buttonSizeEPrice;
  var stackType = pricing.ePrice && isDisplayingEprice ? 'ePrice' : 'dPrice';
  var defaultPrice = getDefaultPriceItem();
  var incentiveMap = mapIncentiveKeys(incentives);
  var isMobile = deviceType === 'MOBILE';
  var priceStack = pricing[stackType];
  var finalPrice = filterFinal(priceStack);
  var vdpSummary = [_objectSpread2({}, loan, {
    type: 'LOAN'
  }), _objectSpread2({}, lease, {
    type: 'LEASE'
  }), _objectSpread2({}, finalPrice[0])]; // TODO: discuss adding this to IDC instead of preference

  var vehicleAccountId = accountInfo.id;
  var accountId = getAccountId(requestData);
  var isVehicleOffSite = accountId !== vehicleAccountId;

  if (showOnlyMSRPForSharedInventory === 'true' && isVehicleOffSite) {
    priceStack = filterMSRP(priceStack, retailPrice);
  }

  var toggleModal = function toggleModal() {
    var incentiveId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (incentiveId && !isModalVisible) {
      setIncentive(_objectSpread2({}, incentiveMap[incentiveId], {
        key: incentiveId
      }));
      setIsModalVisible(true);
    } else {
      setIncentive(null);
      setIsModalVisible(false);
    }
  };

  var incentiveModal = null;

  if (Object.keys(incentiveMap).length > 0 && incentive) {
    var flattenedIncentive = _objectSpread2({}, incentive);

    if (layout === VDP) {
      // Incentive data from WIS is in object form
      flattenedIncentive = _objectSpread2({}, incentive, {
        disclaimer: incentive.disclaimer[locale],
        offerDetails: incentive.offerDetails[locale],
        shortTitle: incentive.shortTitle[locale],
        title: incentive.title[locale]
      });
    }

    incentiveModal = React.createElement(Common, {
      render: function render(_ref2) {
        var sitemap = _ref2.sitemap;
        return React.createElement(IncentiveModal, {
          incentive: flattenedIncentive,
          isOpen: isModalVisible,
          isMobile: isMobile,
          onModalClose: toggleModal,
          newListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_NEW'),
          usedListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_USED'),
          locale: locale,
          widgetInfo: requestData,
          account: accountInfo
        });
      }
    });
  }

  var vehicleCondition = condition.replace(/\s/g, ' ').toLowerCase();
  var vehicleCssClass = condition ? "inv-type-".concat(vehicleCondition) : '';
  var priceStackLength = priceStack && Object.keys(priceStack).length || 0; // START TEMP: in-place mutations
  // TODO: remove once web-inventory-service includes proper logic for isFinalPrice
  // gets all final price items in the stack, sets isFinalPrice=false to all but last in stack
  // there should be only 1 final price in stack

  var finalPriceIndexes = [];

  if (priceStack) {
    priceStack.forEach(function (item, i) {
      return item.isFinalPrice && finalPriceIndexes.push(i);
    });
  }

  if (finalPriceIndexes.length > 1) {
    var extraFinalPrices = finalPriceIndexes.slice(0, finalPriceIndexes.length - 1);
    extraFinalPrices.forEach(function (item) {
      priceStack[item].isFinalPrice = false;
    });
  } // If there is a "stacked incentive final"/SIF item, this should be set as final price


  var hasSIF = priceStack && priceStack.find(function (item) {
    return item.type === 'SIF';
  });

  if (hasSIF) {
    /* eslint no-param-reassign: 0 */
    // clear isFinalPrice
    priceStack.some(function (item) {
      var found = item.isFinalPrice;

      if (found) {
        item.isFinalPrice = false;
      }

      return found;
    }); // add to SIF item

    priceStack.some(function (item) {
      var found = item.type === 'SIF';

      if (found) {
        item.isFinalPrice = true;
      }

      return found;
    });
  } // END TEMP


  var priceItems = priceStack && priceStackLength > 0 ? React.createElement(Common, {
    render: function render() {
      return React.createElement(React.Fragment, null, incentiveModal, priceStack.map(function (item, idx) {
        var isFirstItem = !idx;
        var key = "price-item-".concat(item.typeClass && item.typeClass.toLowerCase() || 'none', "-").concat(priceStackLength - idx);
        return React.createElement(PriceItem, _extends({
          item: item,
          stackType: stackType,
          isMobile: isMobile,
          vehicleCssClass: vehicleCssClass,
          isFirstItem: isFirstItem,
          vehicleId: vehicleId
        }, {
          incentives: incentiveMap,
          handleDetailClick: toggleModal,
          prefs: {
            priceDiscountColor: priceDiscountColor,
            finalPriceSize: finalPriceSize,
            finalPriceColor: finalPriceColor,
            showTitlePriceLabel: showTitlePriceLabel
          },
          key: key
        }));
      }));
    }
  }) : React.createElement(PriceItem, _extends({
    item: defaultPrice,
    stackType: stackType,
    incentives: {},
    isMobile: isMobile,
    vehicleCssClass: vehicleCssClass,
    vehicleId: vehicleId
  }, {
    isLastItem: true,
    isFirstItem: true
  })); // ENABLED -> E-price is enabled/avaialble for the account, uuid combination.
  // DISABLED -> E-price is disabled/not available for the account, uuid combination. Reason for non availabilty is given in the reason string
  // NON_APPLICABLE -> E-price is not applicable for the account and uuid combination.

  var ePriceStatus = pricing.ePriceStatus,
      ePrice = pricing.ePrice,
      ePriceButtonLabel = pricing.ePriceButtonLabel;
  var hasEpriceStatus = ePriceStatus && ePriceStatus !== 'NON_APPLICABLE';
  var shouldDisplayEprice = showInstantEpriceForSharedInventory !== 'false' || !isVehicleOffSite;

  var _showEPrice = function showEPrice(id) {
    return setIsDisplayingEprice(id === vehicleId && id !== 'none');
  };

  var instantEPrice = hasEpriceStatus && shouldDisplayEprice && !isDisplayingEprice ? React.createElement(InstantEpriceContainer, {
    showEPrice: function showEPrice(id) {
      return _showEPrice(id);
    },
    instantEpriceShowAllAfterLeadSubmit: instantEpriceShowAllAfterLeadSubmit,
    ePriceDetail: ePrice,
    widgetInfo: _objectSpread2({}, requestData, {
      pageAlias: pageAlias,
      vehicleId: vehicleId,
      vehicleCategory: vehicleCategory
    }),
    buttonLabel: ePriceButtonLabel,
    buttonStyle: buttonStyleEPrice,
    buttonSize: buttonSizeEPrice,
    preventMultipleEpriceLeads: instantEpricePreventMultipleEpriceLeads === 'true',
    isMobile: isMobile,
    disabled: ePriceStatus && ePriceStatus === 'DISABLED'
  }) : null;
  var pricingSummary = layout === VDP ? React.createElement(PricingSummaryContainer, {
    prefs: prefs,
    summary: vdpSummary,
    widgetInfo: requestData,
    dealerAddress: dealerAddress,
    dealershipName: accountInfo.name
  }) : React.createElement(React.Fragment, null, (loan && loan.value || lease && lease.value) && React.createElement(Payments, {
    loan: loan,
    lease: lease,
    isMobile: isMobile,
    accountInfo: accountInfo
  }));
  return React.createElement(React.Fragment, null, React.createElement(PricingWrapper, {
    vehicleCssClass: vehicleCssClass
  }, priceItems, layout !== VDP && pricingSummary), layout !== VDP ? flags['ws-inv-listing-show-instant-eprice'] && instantEPrice : instantEPrice, layout === VDP && pricingSummary);
};

PricingDetail.defaultProps = {
  vehicleCategory: 'AUTO',
  incentives: {},
  accountInfo: {},
  layout: SRP
};
PricingDetail.propTypes = {
  pricing: PropTypes.shape({
    // individual price items are validated by PriceItem component
    dPrice: PropTypes.arrayOf(PropTypes.object),
    ePrice: PropTypes.arrayOf(PropTypes.object),
    vehicle: PropTypes.shape({}),
    lease: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    }),
    loan: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    }),
    retailPrice: PropTypes.string.isRequired,
    ePriceStatus: PropTypes.string,
    ePriceButtonLabel: PropTypes.string
  }).isRequired,
  incentives: PropTypes.shape({}),
  accountInfo: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }),
  vehicleId: PropTypes.string.isRequired,
  vehicleCategory: PropTypes.string,
  condition: PropTypes.string.isRequired,
  pageAlias: PropTypes.string.isRequired,
  layout: PropTypes.string
};

export default PricingDetail;
//# sourceMappingURL=es.js.map



//////////////////
// WEBPACK FOOTER
// ./~/wsm-pricing-display/dist/es.js
// module id = 62
// module chunks = 0